export const GET_PROGRAM_DIVISIONS = "GET_PROGRAM_DIVISIONS";
export const GET_PROGRAM_DIVISION_BY_ID = "GET_PROGRAM_DIVISION_BY_ID";
export const UPDATE_PROGRAM_DIVISION = "UPDATE_PROGRAM_DIVISION";
export const DELETE_PROGRAM_DIVISION = "DELETE_PROGRAM_DIVISION";
export const CREATE_PROGRAM_DIVISION = "CREATE_PROGRAM_DIVISION";
